export default "__VITE_ASSET__D0OjE3ww__"